import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { UserProfileService } from '../services/user-profile.service';
import { APP_ROUTES } from 'src/app/shared/enums/appRoutes.enum';

/**
 * When `isSuperUser !== true`, we redirect to HOME rather than LOGIN —
 * a non-admin authenticated user is not unauthenticated, they're simply
 * not entitled to the admin area. On profile-fetch error we also redirect
 * HOME (fail-closed).
 */
export const superUserGuard: CanActivateFn = (): Observable<boolean> => {
  const userProfileService = inject(UserProfileService);
  const router = inject(Router);

  return userProfileService.getUserProfile().pipe(
    take(1),
    map(profile => {
      if (profile?.isSuperUser === true) {
        return true;
      }
      router.navigate([APP_ROUTES.HOME]);
      return false;
    }),
    catchError(() => {
      router.navigate([APP_ROUTES.HOME]);
      return of(false);
    })
  );
};
